import { FC, ReactElement } from 'react';

import { Navigate } from 'react-router-dom';

import { routeNames } from '../constants/routes';
import { useTypedSelector } from '../hooks/useTypedSelector';

// Флаг для отключения проверки прав на локальном окружении (для разработки)
const IS_LOCAL_DEV = process.env.NODE_ENV === 'development' && 
  (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'));

interface IProps {
  allowedRoles?: string[];
  redirectToErrPage?: boolean;
  returnedElement?: ReactElement | null;
}

const PermissionWrapper: FC<IProps> = ({
  allowedRoles,
  redirectToErrPage = true,
  returnedElement = null,
  children,
}) => {
  const userRole = useTypedSelector((state) => state.currentUser.role);

  // На локальном окружении пропускаем проверку прав
  if (IS_LOCAL_DEV) {
    return <>{children}</>;
  }

  const roles = allowedRoles ? allowedRoles : [];
  const acceptedRoles = [ 'superadmin', ...roles ];

  return userRole ? (
    acceptedRoles.includes(userRole) ? (
      <>{children}</>
    ) : redirectToErrPage ? (
      <Navigate to={routeNames.accessEnded} replace />
    ) : (
      returnedElement
    )
  ) : null;
};

export default PermissionWrapper;
